/**
 * Adds `found` to a search profile's `selected` ids: what was chosen keeps its
 * place, the new ones follow in the order they came, and nothing is listed
 * twice — the comune each ring was drawn around is in its own ring, and two
 * rings overlap wherever two chosen comuni are neighbours.
 */
export function addCriteria(selected: readonly string[], found: readonly string[]): string[] {
  const seen = new Set(selected);
  const added: string[] = [];
  for (const id of found) {
    if (seen.has(id)) continue;
    seen.add(id);
    added.push(id);
  }
  return [...selected, ...added];
}
